import {
  Button,
  Divider,
  FileInput,
  FormGroup,
  Switch,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { api, apiOperacao } from "../../api";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";

interface EmpresaPgdasProps {
  handlesDownloadpgdas: () => void;
  receita_bruta: string;
  cod_acesso: string;
  haldleDisableValidSimples: () => void;
  handleReceitaBrutaValid: (vl: string) => void;
  handleCodAcesso: (vl: string) => void;
  goToTab: (tabId: string) => void;
}

interface EmpresaPgdasState {
  handlesDownloadpgdas: () => void;
  receita_bruta: string;
  cod_acesso: string;
  haldleDisableValidSimples: () => void;
  handleReceitaBrutaValid: (vl: string) => void;
  handleCodAcesso: (vl: string) => void;
  selectedAnexo: string
  indicadorComparacao: boolean
}

@observer
export default class EmpresaPgdas extends React.Component<EmpresaPgdasProps, EmpresaPgdasState> {

  obs = observable({
    validando: false as boolean,
    nome_certificado: "Selecione um arquivo" as string,
    open_ajuda: false as boolean,
  })

  constructor(props) {
    super(props);

    this.state = {
      handlesDownloadpgdas: props.handlesDownloadpgdas,
      receita_bruta: props.receita_bruta,
      haldleDisableValidSimples: props.haldleDisableValidSimples,

      handleReceitaBrutaValid: props.handleReceitaBrutaValid,
      cod_acesso: props.cod_acesso,
      handleCodAcesso: props.handleCodAcesso,
      selectedAnexo: EmpresaStore.obs.empresa_edit.anexo,
      indicadorComparacao: EmpresaStore.obs.empresa_edit.indicadorComparacao
    };
  }

  changeIndicadorComparacao = (e) => {
    const newValue = e.target.checked;
    this.setState({ indicadorComparacao: newValue })
    EmpresaStore.obs.empresa_edit.indicadorComparacao = newValue;
  };

  handleGoToTab = (tab: string) => {
    this.props.goToTab(tab);
  };

  render() {

    const handleFileChange = async (event) => {
      this.obs.validando = true;

      const file = event.target.files[0];

      this.obs.nome_certificado = file.name

      var cnpj = EmpresaStore.obs.empresa_edit.cnpj;

      var data = new FormData();
      data.append("filepgdas", file);
      data.append("cnpj", cnpj);

      try{

        let resp = await apiOperacao("pgdas").post("/pgdas/empresa/upload", data)

        if (resp.data.ok) {
          EmpresaStore.obs.existe_pdf_pgdas = true
          this.obs.nome_certificado = "Selecione um arquivo"

          toast.success('Arquivo importado com sucesso!', {});

          await EmpresaStore.load();

        } else {

          toast.error(resp.data.error, {});
        }

      }catch(e){}

      this.obs.validando = false;

    };

    const handleButtonClick = () => {
      document.getElementById('fileInput').click();
    };

    return (

      <>

        <div style={{ width: 1000 }}>

          {!EmpresaStore.obs.empresa_edit.filial ?
            <>
              {EmpresaStore.obs.existe_pdf_pgdas ?
                <>
                  <MDBCol md="12">
                    <h3 className="info-cert">
                      Essa empresa possui uma PGDASD-DECLARAÇÃO.
                    </h3>
                  </MDBCol>

                  <MDBCol md="12">
                    <div style={{ display: "flex" }}>
                      <div>
                        <Button onClick={handleButtonClick} intent="danger">Alterar PGDAS</Button>
                        <input
                          id="fileInput"
                          type="file"
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                        />
                      </div>
                      <Button
                        style={{ marginLeft: 10 }}
                        icon="download"
                        onClick={this.state.handlesDownloadpgdas}
                      >
                        Visualizar PGDAS
                      </Button>
                    </div>
                  </MDBCol>

                  <br />
                  <Divider />
                  <br />

                  <MDBCol md="12">
                    <FormGroup label="Indicador de Comparação" labelInfo={<>
                      &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
                    </>
                    }>
                      <Switch
                        className="select-regras"
                        label={EmpresaStore.obs.empresa_edit.indicadorComparacao ? "Ativado" : "Desativado"}
                        checked={EmpresaStore.obs.empresa_edit.indicadorComparacao}
                        onChange={(e: any) => this.changeIndicadorComparacao(e)} />
                    </FormGroup>
                  </MDBCol>

                  <Divider />
                  <br />

                  <MDBCol md="12">
                    <p>
                      As notificações de cópia dos arquivos DAS / PGDAS-D (E-mail e WhatsApp) são configuradas na aba{" "}
                      <button
                        onClick={() => this.handleGoToTab("notificacoes")}
                        style={{ padding: 0, border: "none", background: "none", fontWeight: "bold", textDecoration: "underline", color: "#3579ea", cursor: "pointer" }}
                      >
                        Notificações
                      </button>.
                    </p>
                  </MDBCol>

                </>

                :

                <MDBCol md="12">
                  <FormGroup label="Selecionar arquivo PGDAS">
                    <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={handleFileChange} />
                  </FormGroup>
                </MDBCol>
              }

              <LoadingModal open={this.obs.validando} onClose={() => this.obs.validando = false} title={"Validando PGDAS"} />

            </>
            :
            <MDBCol>
              <h2 className="title">Exclusivo para Empresas Matriz</h2>
            </MDBCol>
          }

        </div>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`
          Indica se há a necessidade de comparação dos valores enviados na entrada com os valores calculados antes da transmissão.
        `} />

      </>
    );
  }
}
